<template>
	<div class="chat-msg-item " :class="{ active: active, 'is-selecting': selecting, 'is-selected': selected }">
		<div class="chat-msg-tip" v-if="msgInfo.type == $enums.MESSAGE_TYPE.TIP_TEXT">
			{{ msgInfo.content }}
		</div>
		<div class="chat-msg-tip" v-else-if="msgInfo.type == $enums.MESSAGE_TYPE.TIP_TIME">
			{{ $date.toTimeText(msgInfo.sendTime) }}
		</div>
		<div class="chat-msg-row" v-else-if="isNormal" @click="onSelectClick">
		<div class="chat-msg-normal " :class="{ 'chat-msg-mine': mine }">
			<div class="head-image">
				<head-image :name="showName || msgInfo.sendNickName" :size="38" :url="headImage || msgInfo.headImage"
					:isAddFriend="isManager || isOwner || isAddFriend" :id="msgInfo.sendId"></head-image>
			</div>
			<div class="chat-msg-content">
				<div class="chat-msg-top">
					<div style="display: flex;" :class="msgInfo.selfSend && 'self-msg-top'">
						<div :class="{ 'official-name': isOfficialName }">{{ showName || msgInfo.sendNickName }}{{ isOfficialName ? '【官方】' : '' }}</div>
						<template v-if="msgInfo.groupId && !msgInfo.selfSend">
							<el-tag v-if="isGroupOwner(msgInfo.sendId)" class="tag" size="mini"
								type="danger">群主</el-tag>
							<el-tag v-if="isGroupManager(msgInfo.sendId)" class="tag" size="mini"
								type="primary">管理员</el-tag>
						</template>
						<div class="send-time">{{ moment(msgInfo.sendTime).format('YYYY/MM/DD HH:mm:ss') }}</div>
					</div>
				</div>

				<div class="chat-msg-bottom" @contextmenu.prevent="showMessageMenu($event)">
					<div ref="chatMsgBox">
						<span class="chat-msg-text" v-if="msgInfo.type == $enums.MESSAGE_TYPE.TEXT"
							v-html="htmlText"></span>
						<div class="chat-msg-image" v-if="msgInfo.type == $enums.MESSAGE_TYPE.IMAGE">
							<div v-loading="loading" element-loading-text="上传中.."
								element-loading-background="rgba(0, 0, 0, 0.4)">
								<cimage :msgInfo="msgInfo" className="send-image"></cimage>
								<!-- <el-image class="send-image" lazy fit="cover"
									:src="JSON.parse(msgInfo.content).thumbUrl || JSON.parse(msgInfo.content).originUrl"
									:preview-src-list="[JSON.parse(msgInfo.content).originUrl || JSON.parse(msgInfo.content).thumbUrl]">
									<div slot="error" class="image-slot">
										<i class="el-icon-picture-outline"></i>
									</div>
								</el-image> -->
							</div>
							<div v-if="showUploadMeta" class="upload-meta">
								<div class="upload-progress-row">
									<div class="upload-progress-bar">
										<div class="upload-progress-inner" :style="{ width: uploadProgressWidth }"></div>
									</div>
									<span class="upload-cancel el-icon-close" title="取消上传" @click.stop="onCancelUpload"></span>
								</div>
								<div class="upload-progress-text">{{ uploadMetaText }}</div>
							</div>
							<div v-if="loadFail && msgInfo.failReason" class="upload-fail-reason">{{ msgInfo.failReason }}</div>
							<span title="点击重新发送" v-show="loadFail" @click.stop="onSendFail" class="send-fail el-icon-warning">
							</span>
						</div>
						<div class="chat-msg-video" v-if="msgInfo.type == $enums.MESSAGE_TYPE.VIDEO" v-loading="loading">
							<video class="send-video" controls preload="none"
								:poster="data.coverUrl"
								:src="data.videoUrl" />
							<div v-if="showUploadMeta" class="upload-meta">
								<div class="upload-progress-row">
									<div class="upload-progress-bar">
										<div class="upload-progress-inner" :style="{ width: uploadProgressWidth }"></div>
									</div>
									<span class="upload-cancel el-icon-close" title="取消上传" @click.stop="onCancelUpload"></span>
								</div>
								<div class="upload-progress-text">{{ uploadMetaText }}</div>
							</div>
							<div v-if="loadFail && msgInfo.failReason" class="upload-fail-reason">{{ msgInfo.failReason }}</div>
							<span title="点击重新发送" v-show="loadFail" @click.stop="onSendFail"
								class="send-fail el-icon-warning"></span>
						</div>
						<div class="chat-msg-file" v-if="msgInfo.type == $enums.MESSAGE_TYPE.FILE">
							<div class="chat-file-box" v-loading="loading">
								<div class="chat-file-info">
									<el-link class="chat-file-name" :underline="true" target="_blank" type="primary"
										:href="data.url" :download="data.name">{{ data.name }}</el-link>
									<div class="chat-file-size">{{ fileSize }}</div>
								</div>
								<div class="chat-file-icon">
									<span type="primary" class="el-icon-document"></span>
								</div>
							</div>
							<div v-if="showUploadMeta" class="upload-meta">
								<div class="upload-progress-row">
									<div class="upload-progress-bar">
										<div class="upload-progress-inner" :style="{ width: uploadProgressWidth }"></div>
									</div>
									<span class="upload-cancel el-icon-close" title="取消上传" @click.stop="onCancelUpload"></span>
								</div>
								<div class="upload-progress-text">{{ uploadMetaText }}</div>
							</div>
							<div v-if="loadFail && msgInfo.failReason" class="upload-fail-reason">{{ msgInfo.failReason }}</div>
							<span title="点击重新发送" v-show="loadFail" @click.stop="onSendFail"
								class="send-fail el-icon-warning"></span>
						</div>
					</div>
					<div class="chat-msg-voice" v-if="msgInfo.type == $enums.MESSAGE_TYPE.AUDIO" @click="onPlayVoice()">
						<audio controls :src="data.url"></audio>
					</div>
					<div class="chat-msg-card" v-if="msgInfo.type == $enums.MESSAGE_TYPE.GROUP_CARD"
						@click="onShowGroupInfo()">
						<div class="card-body">
							<head-image :url="data.headImage" :name="data.groupName" radius="10%"
								style="position: relative;" :enable-group-at="false"></head-image>
							<div class="name">{{ data.groupName }}</div>
						</div>
						<div class="card-tip">群ID: {{ data.groupId }}</div>
					</div>
					<div class="chat-msg-card" v-if="msgInfo.type == $enums.MESSAGE_TYPE.USER_CARD"
						@click="onShowUserInfo()">
						<div class="card-body">
							<head-image :url="data.headImage" :name="data.nickName" radius="10%"
								style="position: relative;" :isAddFriend="true" :id="data.userId"
								:enable-group-at="false"></head-image>
							<div class="name">{{ data.nickName }}</div>
						</div>
						<div class="card-tip">用户ID: {{ data.userId }}</div>
					</div>
					<div class="chat-action chat-msg-text" v-if="isAction">
						<span v-if="msgInfo.type == $enums.MESSAGE_TYPE.ACT_RT_VOICE" title="重新呼叫"
							@click="$emit('call')" class="iconfont icon-chat-voice"></span>
						<span v-if="msgInfo.type == $enums.MESSAGE_TYPE.ACT_RT_VIDEO" title="重新呼叫"
							@click="$emit('call')" class="iconfont icon-chat-video"></span>
						<span>{{ msgInfo.content }}</span>
					</div>
					<div class="quote-message" v-if="msgInfo.quoteMessage"
						@contextmenu.prevent.stop="showQuoteMenu($event)">
						<chat-quote-message :msgInfo="msgInfo.quoteMessage"
							@click.native.stop="$emit('locateQuote', msgInfo)"
							:showName="quoteShowName"></chat-quote-message>
					</div>
					<div class="chat-msg-status" v-if="!isAction">
						<span v-if="messageStatusText" :class="messageStatusClass">{{ messageStatusText }}</span>
					</div>
					<div class="chat-receipt" v-if="msgInfo.receipt" @click="onShowReadedBox">
						<span v-if="msgInfo.receiptOk" class="icon iconfont icon-ok" title="全体已读"></span>
						<span v-else>{{ msgInfo.readedCount }}人已读</span>
					</div>
				</div>
			</div>
		</div>
			<div v-if="selecting && canForward" class="msg-select-col" @click.stop="onToggleSelect">
				<span class="msg-check" :class="{ checked: selected }">
					<i v-if="selected" class="el-icon-check"></i>
				</span>
			</div>
		</div>
		<right-menu ref="rightMenu" @select="onSelectMenu"></right-menu>
		<chat-group-readed v-if="msgInfo.receipt" ref="chatGroupReadedBox" :msgInfo="msgInfo" :group="group"
			:groupMembers="groupMembers"></chat-group-readed>
	</div>
</template>

<script>
import Cimage from "@/components/common/Cimage.vue";
import { formatMessageHtml } from "@/utils/common";
import { resolveMediaUrlsInObject } from "@/utils/mediaUrl";
import moment from 'moment';
import HeadImage from "../common/HeadImage.vue";
import RightMenu from '../common/RightMenu.vue';
import ChatGroupReaded from './ChatGroupReaded.vue';
import ChatQuoteMessage from "./ChatQuoteMessage.vue";
export default {
	name: "messageItem",
	components: {
		HeadImage,
		RightMenu,
		ChatGroupReaded,
		ChatQuoteMessage,
		Cimage
	},
	props: {
		mode: {
			type: Number,
			default: 1
		},
		active: {
			type: Boolean,
			default: false
		},
		mine: {
			type: Boolean,
			required: true
		},
		headImage: {
			type: String,
			default: ''
		},
		showName: {
			type: String,
			required: true
		},
		quoteShowName: {
			type: String,
			default: ''
		},
		msgInfo: {
			type: Object,
			required: true
		},
		group: {
			type: Object,
		},
		groupMembers: {
			type: Array
		},
		groupManagers: {
			type: Array
		},
		chatType: {
			default: 'PRIVATE',
			type: String,
		},
		selecting: {
			type: Boolean,
			default: false
		},
		selected: {
			type: Boolean,
			default: false
		}
	},
	data() {
		return {
			moment,
			isDownloading: false,
			groupCardLoading: false,
		}
	},
	methods: {
		groupTypeText(groupType) {
			if (groupType == 1) return "普通群";
			if (groupType == 2) return "工作群";
			if (groupType == 3) return "频道";
			return "未知";
		},
		openGroupChat(group) {
			if (!group || !group.id) {
				return;
			}
			let chat = {
				type: "GROUP",
				targetId: group.id,
				showName: group.showGroupName || group.name,
				headImage: group.headImageThumb || group.headImage,
			};
			this.$store.commit("addGroup", group);
			this.$store.commit("openChat", { ...chat, activeChat: true });
			this.$router.push("/home/chat");
		},
		async onShowGroupInfo() {
			if (this.groupCardLoading) {
				return;
			}
			const groupId = this.data && this.data.groupId;
			if (!groupId) {
				this.$message.warning("群ID无效，无法查看");
				return;
			}
			this.groupCardLoading = true;
			try {
				const group = await this.$http({
					url: `/group/find/${groupId}`,
					method: "get",
				});
				let inGroup = false;
				try {
					const members = await this.$http({
						url: `/group/members/${group.id}`,
						method: "get",
					});
					const myId = this.$store.state.userStore.userInfo.id;
					inGroup = (members || []).some((m) => m.userId == myId && !m.quit);
				} catch (e) {
					// 成员查询失败时不阻断，继续提示用户可去群页面查看
				}

				if (inGroup) {
					this.$confirm(`你已在群聊「${group.name || group.showGroupName || ''}」中，是否前往发送消息？`, "群名片", {
						confirmButtonText: "去聊天",
						cancelButtonText: "取消",
						type: "info",
					}).then(() => {
						this.openGroupChat(group);
					});
					return;
				}

				const notice = (group.notice || "暂无公告").slice(0, 40);
				const groupType = this.groupTypeText(group.groupType);
				this.$confirm(
					`群名称：${group.name || "-"}\n群类型：${groupType}\n群公告：${notice}\n\n你当前不在该群，是否申请加入？`,
					"群名片",
					{
						confirmButtonText: "申请加入",
						cancelButtonText: "取消",
						type: "warning",
					}
				).then(async () => {
					await this.$http({
						url: `/group/join/${group.id}`,
						method: "post",
					});
					this.$message.success("申请已提交，等待管理员审核");
				});
			} catch (e) {
				this.$message.error("群信息查询失败，请稍后重试");
			} finally {
				this.groupCardLoading = false;
			}
		},
		onShowUserInfo() {
			// this.$router.push("/home/friend?id=" + this.data.userId);
		},
		onSendFail() {
			if (!this.loadFail || !this.mine) {
				return;
			}
			const type = this.msgInfo.type;
			const canResend = type == this.$enums.MESSAGE_TYPE.FILE
				|| type == this.$enums.MESSAGE_TYPE.IMAGE
				|| type == this.$enums.MESSAGE_TYPE.VIDEO;
			if (!canResend) {
				this.$message.error('发送失败，请手动重新发送');
				return;
			}
			this.$emit('resend', this.msgInfo);
		},
		onCancelUpload() {
			if (!this.loading || !this.msgInfo || !this.msgInfo.tmpId) {
				return;
			}
			this.$emit('cancel-upload', this.msgInfo);
		},
		showFullImageBox() {
			let imageUrl = this.data.originUrl;
			if (imageUrl) {
				this.$store.commit('showFullImageBox', imageUrl);
			}
		},
		onPlayVoice() {
			if (!this.audio) {
				this.audio = new Audio();
			}
			this.audio.src = this.data.url;
			this.audio.play();
			this.onPlayVoice = 'RUNNING';
		},
		fileNameFromUrl(url, defaultName) {
			try {
				const pathname = new URL(url, window.location.origin).pathname;
				const base = pathname.split('/').pop();
				if (base && base.includes('.')) {
					return decodeURIComponent(base);
				}
			} catch (e) { /* ignore */ }
			return defaultName;
		},
		getDownloadInfo() {
			const type = this.msgInfo.type;
			if (type == this.$enums.MESSAGE_TYPE.FILE) {
				return { url: this.data.url, fileName: this.data.name };
			}
			if (type == this.$enums.MESSAGE_TYPE.IMAGE) {
				const url = this.data.originUrl || this.data.thumbUrl;
				return { url, fileName: this.fileNameFromUrl(url, 'image.png') };
			}
			if (type == this.$enums.MESSAGE_TYPE.VIDEO) {
				const url = this.data.videoUrl;
				return { url, fileName: this.fileNameFromUrl(url, 'video.mp4') };
			}
			return null;
		},
		getCopyMenuItem() {
			const type = this.msgInfo.type;
			if (type == this.$enums.MESSAGE_TYPE.IMAGE) {
				return { key: 'COPY', name: '复制图片', icon: 'el-icon-picture-outline' };
			}
			if (type == this.$enums.MESSAGE_TYPE.VIDEO) {
				return { key: 'COPY', name: '复制视频', icon: 'el-icon-video-camera' };
			}
			if (type == this.$enums.MESSAGE_TYPE.FILE) {
				return { key: 'COPY', name: '复制文件', icon: 'el-icon-document-copy' };
			}
			if (type == this.$enums.MESSAGE_TYPE.USER_CARD) {
				return { key: 'COPY', name: '复制用户ID', icon: 'el-icon-user' };
			}
			if (type == this.$enums.MESSAGE_TYPE.GROUP_CARD) {
				return { key: 'COPY', name: '复制群ID', icon: 'el-icon-user' };
			}
			if (type == this.$enums.MESSAGE_TYPE.TEXT) {
				return { key: 'COPY', name: '复制文本', icon: 'el-icon-document-copy' };
			}
		},
		async onDownloadMedia() {
			if (this.isDownloading) {
				return;
			}
			const info = this.getDownloadInfo();
			if (!info || !info.url) {
				this.$message.error('资源地址无效');
				return;
			}
			if (!info.fileName) {
				this.$message.error('文件名为空，无法下载');
				return;
			}
			const { url, fileName } = info;
			const downloadPayload = {
				fileName,
				sizeText: (this.msgInfo.type == this.$enums.MESSAGE_TYPE.FILE && this.data.size)
					? this.fileSize
					: ''
			};
			this.isDownloading = true;
			this.$eventBus && this.$eventBus.$emit('media-download:start', downloadPayload);
			try {
				const response = await fetch(url);
				if (!response.ok) {
					throw new Error('download failed');
				}
				const blob = await response.blob();
				const blobUrl = URL.createObjectURL(blob);
				const link = document.createElement('a');
				link.href = blobUrl;
				link.download = fileName;
				link.style.display = 'none';
				document.body.appendChild(link);
				link.click();
				document.body.removeChild(link);
				URL.revokeObjectURL(blobUrl);
				this.$message.success('下载完成');
			} catch (e) {
				try {
					const link = document.createElement('a');
					link.href = url;
					link.download = fileName;
					link.target = '_blank';
					link.rel = 'noopener noreferrer';
					link.style.display = 'none';
					document.body.appendChild(link);
					link.click();
					document.body.removeChild(link);
					this.$message.warning('已尝试由浏览器直接下载');
				} catch (err) {
					this.$message.error('下载失败，请稍后重试');
				}
			} finally {
				this.$eventBus && this.$eventBus.$emit('media-download:end', downloadPayload);
				this.isDownloading = false;
			}
		},
		onToggleSelect(e) {
			if (this.canForward) {
				this.$emit('toggle-select', this.msgInfo, e);
			}
		},
		onSelectClick(e) {
			if (!this.selecting) {
				return;
			}
			this.onToggleSelect(e);
		},
		showMessageMenu(e) {
			if (this.selecting) {
				// this.$refs.rightMenu.open(e, [{
				// 	key: 'FORWARD_SELECTED',
				// 	name: '转发',
				// 	icon: 'el-icon-position'
				// }, {
				// 	key: 'CANCEL_SELECT',
				// 	name: '取消',
				// 	icon: 'el-icon-close'
				// }]);
				return;
			}
			let menuItems = [];
			const downloadInfo = this.getDownloadInfo();
			if (downloadInfo && downloadInfo.url) {
				menuItems.push({
					key: 'DOWNLOAD',
					name: '下载',
					icon: 'el-icon-download'
				});
			}
			if (this.getCopyMenuItem()) {
				menuItems.push(this.getCopyMenuItem());
			}
			menuItems.push({
				key: 'DELETE',
				name: '删除',
				icon: 'el-icon-delete'
			});
			if (this.msgInfo.id) {
				if (this.msgInfo.selfSend) {
					menuItems.push({
						key: 'RECALL',
						name: '撤回',
						icon: 'el-icon-refresh-left'
					});
				}
				if (this.$msgType.isNormal(this.msgInfo.type)) {
					menuItems.push({
						key: 'QUOTE',
						name: '引用',
						icon: 'el-icon-chat-dot-round'
					});
					menuItems.push({
						key: 'FORWARD',
						name: '转发',
						icon: 'el-icon-position'
					});
				}
				if ((this.isOwner || this.isManager) && this.$msgType.isNormal(this.msgInfo.type) && this.chatType === 'GROUP') {
					menuItems.push({
						key: 'TOP',
						name: '置顶',
						icon: 'el-icon-top'
					});
				}
				if ((this.isOwner || this.isManager) && this.$msgType.isNormal(this.msgInfo.type) && !this.msgInfo.selfSend && this.chatType === 'GROUP') {
					menuItems.push({
						key: 'RECALLALL',
						name: '撤回(所有人)',
						icon: 'el-icon-circle-close'
					});
				}
			}

			this.$refs.rightMenu.open(e, menuItems);
		},
		showQuoteMenu(e) {
			let menuItems = [];
			if (this.msgInfo.quoteMessage &&
				this.msgInfo.quoteMessage.status != this.$enums.MESSAGE_STATUS.RECALL) {
				menuItems.push({
					key: 'LOCATE_QUOTE',
					name: '定位到原消息',
					icon: 'el-icon-location-outline'
				});
			}
			this.$refs.rightMenu.open(e, menuItems);
		},
		onSelectMenu(item) {
			if (item.key === 'DOWNLOAD') {
				this.onDownloadMedia();
				return;
			}
			// 菜单id转驼峰作为事件key
			let eventKey = item.key.toLowerCase().replace(/_([a-z])/g, (g) => g[1].toUpperCase());
			this.$emit(eventKey, this.msgInfo);
		},
		onShowReadedBox() {
			let rect = this.$refs.chatMsgBox.getBoundingClientRect();
			this.$refs.chatGroupReadedBox.open(rect);
		},
		isGroupOwner(userId) {
			return this.group.ownerId == userId;
		},
		isGroupManager(userId) {
			let m = this.groupManagers.find(m => m.userId == userId);
			return m && m.isManager
		},
	},
	computed: {
		isOfficialName() {
			const msg = this.msgInfo;
			if (!msg) {
				return false;
			}
			if (Number(msg.userTag) === 1) {
				return true;
			}
			const userInfo = this.$store.state.userStore.userInfo || {};
			if (msg.sendId == userInfo.id && Number(userInfo.userTag) === 1) {
				return true;
			}
			if (Array.isArray(this.groupMembers) && this.groupMembers.length) {
				const member = this.groupMembers.find((m) => m.userId == msg.sendId);
				if (member && Number(member.userTag) === 1) {
					return true;
				}
			}
			const friend = this.$store.getters.findFriend(msg.sendId);
			return !!(friend && Number(friend.userTag) === 1);
		},
		loading() {
			return this.msgInfo.loadStatus && this.msgInfo.loadStatus === "loading";
		},
		loadFail() {
			return this.msgInfo.loadStatus && this.msgInfo.loadStatus === "fail";
		},
		messageStatusText() {
			if (!this.msgInfo.selfSend) return '';
			if (this.msgInfo.loadStatus === 'loading') return '发送中';
			if (this.msgInfo.loadStatus === 'fail') return '发送失败';
			if (this.msgInfo.groupId) return '已发送';
			return this.msgInfo.status == this.$enums.MESSAGE_STATUS.READED ? '已读' : '未读';
		},
		messageStatusClass() {
			if (this.msgInfo.loadStatus === 'loading') return 'chat-sending';
			if (this.msgInfo.loadStatus === 'fail') return 'chat-fail';
			if (this.msgInfo.groupId) return 'chat-sent';
			return this.msgInfo.status == this.$enums.MESSAGE_STATUS.READED ? 'chat-readed' : 'chat-unread';
		},
		showUploadMeta() {
			const type = this.msgInfo.type;
			const isUploadType = type == this.$enums.MESSAGE_TYPE.FILE
				|| type == this.$enums.MESSAGE_TYPE.IMAGE
				|| type == this.$enums.MESSAGE_TYPE.VIDEO;
			return this.loading && this.msgInfo.selfSend && isUploadType;
		},
		uploadMetaText() {
			const percent = Number.isFinite(this.msgInfo.uploadPercent)
				? this.msgInfo.uploadPercent
				: 0;
			return `上传中 ${percent}%`;
		},
		uploadProgressWidth() {
			const percent = Number.isFinite(this.msgInfo.uploadPercent) ? this.msgInfo.uploadPercent : 0;
			const safePercent = Math.max(1, Math.min(percent, 99));
			return `${safePercent}%`;
		},
		data() {
			const parsed = JSON.parse(this.msgInfo.content);
			return resolveMediaUrlsInObject(parsed, this.$store.state.configStore.s3Url);
		},
		fileSize() {
			let size = this.data.size;
			if (size > 1024 * 1024) {
				return Math.round(size / 1024 / 1024) + "M";
			}
			if (size > 1024) {
				return Math.round(size / 1024) + "KB";
			}
			return size + "B";
		},
		isAction() {
			return this.$msgType.isAction(this.msgInfo.type);
		},
		isNormal() {
			const type = this.msgInfo.type;
			return this.$msgType.isNormal(type) || this.$msgType.isAction(type)
		},
		canForward() {
			return !!(this.msgInfo && this.msgInfo.id
				&& this.$msgType.isNormal(this.msgInfo.type)
				&& this.msgInfo.status != this.$enums.MESSAGE_STATUS.RECALL
				&& this.msgInfo.loadStatus != 'loading');
		},
		isOwner() {
			let userId = this.$store.state.userStore.userInfo.id;
			return this.group && userId == this.group.ownerId
		},
		isManager() {
			let userId = this.$store.state.userStore.userInfo.id;
			let m = this.groupManagers.find((m) => m.userId == userId);
			return m && m.isManager;
		},
		isAddFriend() {
			return this.group?.isAddFriend;
		},
		htmlText() {
			const color = this.msgInfo.selfSend ? 'white' : '';
			return formatMessageHtml(this.msgInfo.content, color, 'emoji-normal');
		}
	}
}
</script>

<style lang="scss">
.chat-msg-item {
	padding: 2px 10px;
	border-radius: 10px;

	&.active {
		background: #E1EAF7;
	}

	&.is-selecting {
		cursor: pointer;
		user-select: none;
		-webkit-user-select: none;

		.chat-msg-text {
			user-select: none;
			-webkit-user-select: none;
		}
	}

	&.is-selected {
		background: rgba(9, 47, 128, 0.06);
	}

	.chat-msg-row {
		display: flex;
		align-items: flex-start;
		width: 100%;
	}

	.msg-select-col {
		flex: 0 0 36px;
		width: 36px;
		display: flex;
		align-items: center;
		justify-content: center;
		height: 40px;
		margin-top: 8px;
		cursor: pointer;
	}

	.msg-check {
		width: 22px;
		height: 22px;
		border: 2px solid #c5c9d1;
		border-radius: 50%;
		box-sizing: border-box;
		color: #fff;
		font-size: 12px;
		display: flex;
		align-items: center;
		justify-content: center;
		background: #fff;

		&.checked {
			background: var(--im-color-primary);
			border-color: var(--im-color-primary);
		}
	}

	.chat-msg-tip {
		line-height: 50px;
		font-size: var(--im-font-size-small);
		color: var(--im-text-color-light);
		word-break: break-all;
	}

	.chat-msg-normal {
		position: relative;
		flex: 1;
		min-width: 0;
		font-size: 0;
		padding-left: 48px;
		min-height: 50px;
		margin: 5px 0;

		.head-image {
			position: absolute;
			width: 40px;
			height: 40px;
			top: 0;
			left: 0;
		}

		.chat-msg-content {
			text-align: left;

			.send-fail {
				color: #e60c0c;
				font-size: 30px;
				cursor: pointer;
				margin: 0 20px;
			}

			.send-time {
				font-size: var(--im-font-size-small);
				color: #333;
				margin: 0 10px;
			}

			.chat-msg-top {
				display: flex;
				flex-wrap: nowrap;
				color: #888;
				font-size: var(--im-font-size);
				line-height: 20px;
				align-items: center;

				.tag {
					margin: 0 5px;
					padding: 0 5px;
					font-size: 10px;
					border: 0;
					border-radius: 3px;
				}
			}

			.self-msg-top {
				display: flex;
			}

			.chat-msg-bottom {
				display: inline-block;
				padding-right: 300px;
				@media screen and (max-width: 768px) {
					padding-right: 0px;
				}
				padding-left: 5px;

				.chat-msg-text {
					display: inline-block;
					position: relative;
					line-height: 26px;
					padding: 6px 10px;
					background: var(--im-background);
					border-radius: 10px;
					font-size: var(--im-font-size);
					text-align: left;
					white-space: pre-wrap;
					word-break: break-all;
					user-select: text;
					-webkit-user-select: text;

					&:after {
						content: "";
						position: absolute;
						left: -10px;
						top: 13px;
						width: 0;
						height: 0;
						border-style: solid dashed dashed;
						border-color: #eee transparent transparent;
						overflow: hidden;
						border-width: 10px;
					}
				}

				.chat-msg-image {
					display: flex;
					flex-wrap: nowrap;
					flex-direction: row;
					align-items: center;
					margin-top: 3px;
					position: relative;

					.send-image {
						min-width: 150px;
						min-height: 150px;
						max-width: 400px;
						height: 300px;
						border-radius: 8px;
						cursor: pointer;
						object-fit: contain;
						background: rgba(0, 0, 0, 0.1);
						display: flex;
						justify-content: center;
						align-items: center;
					}

					.image-slot {
						font-size: 40px;
					}
				}

				.upload-meta {
					margin-left: 10px;
					color: var(--im-color-primary);
					font-size: var(--im-font-size-small);
					white-space: nowrap;

					.upload-progress-row {
						display: flex;
						align-items: center;
						gap: 8px;
					}

					.upload-progress-bar {
						width: 142px;
						height: 4px;
						border-radius: 999px;
						background: rgba(80, 80, 80, 0.18);
						overflow: hidden;
						margin-bottom: 6px;
					}

					.upload-progress-inner {
						height: 100%;
						border-radius: 999px;
						background: linear-gradient(90deg, #4b9bff, #3f7cff);
						transition: width 0.2s linear;
					}

					.upload-progress-text {
						line-height: 1.2;
					}

					.upload-cancel {
						font-size: 12px;
						color: #909399;
						cursor: pointer;
						line-height: 1;
						margin-top: -6px;
					}

					.upload-cancel:hover {
						color: #f56c6c;
					}
				}

				.upload-fail-reason {
					margin: 6px 0 0 10px;
					max-width: 240px;
					color: #f56c6c;
					font-size: var(--im-font-size-small);
					line-height: 1.3;
					word-break: break-all;
				}


				.chat-msg-video {
					display: flex;
					flex-wrap: nowrap;
					flex-direction: row;
					align-items: center;
					margin-top: 3px;

					.send-video {
						min-width: 260px;
						max-width: 360px;
						height: 300px;
						border-radius: 10px;
						overflow: hidden;
						cursor: pointer;
						object-fit: contain;
					}
				}


				.chat-msg-file {
					display: flex;
					flex-wrap: nowrap;
					flex-direction: row;
					align-items: center;
					cursor: pointer;
					margin-top: 3px;
					margin-bottom: 2px;

					.chat-file-box {
						display: flex;
						flex-wrap: nowrap;
						align-items: center;
						min-height: 60px;
						box-shadow: var(--im-box-shadow-light);
						border-radius: 4px;
						padding: 10px 15px;

						.chat-file-info {
							flex: 1;
							height: 100%;
							text-align: left;
							font-size: 14px;
							margin-right: 10px;

							.chat-file-name {
								display: inline-block;
								min-width: 160px;
								max-width: 220px;
								font-size: 14px;
								margin-bottom: 4px;
								white-space: pre-wrap;
								word-break: break-all;
							}

							.chat-file-size {
								font-size: var(--im-font-size-smaller);
								color: var(--im-text-color-light);
							}
						}

						.chat-file-icon {
							font-size: 44px;
							color: #d42e07;
						}
					}

					.send-fail {
						color: #e60c0c;
						font-size: 30px;
						cursor: pointer;
						margin: 0 20px;
					}

				}

				.chat-msg-voice {
					font-size: 14px;
					cursor: pointer;

					audio {
						height: 45px;
						padding: 5px 0;
					}
				}

				.chat-action {
					display: flex;
					align-items: center;

					.iconfont {
						cursor: pointer;
						font-size: 22px;
						padding-right: 8px;
					}
				}

				.quote-message {
					display: block;
					margin-top: 3px;
					cursor: pointer;
				}

				.chat-msg-status {
					display: block;

					.chat-sending {
						font-size: var(--im-font-size-smaller);
						color: var(--im-text-color-light);
					}
					.chat-fail {
						font-size: var(--im-font-size-smaller);
						color: var(--im-color-danger);
					}
					.chat-sent {
						font-size: var(--im-font-size-smaller);
						color: var(--im-text-color-light);
					}
					.chat-readed {
						font-size: var(--im-font-size-smaller);
						color: var(--im-text-color-light);
					}

					.chat-unread {
						font-size: var(--im-font-size-smaller);
						color: var(--im-color-danger);
					}
				}

				.chat-receipt {
					font-size: var(--im-font-size-smaller);
					cursor: pointer;
					color: var(--im-text-color-light);

					.icon-ok {
						font-size: 20px;
						color: var(--im-color-success);
					}
				}

				.chat-at-user {
					padding: 2px 5px;
					border-radius: 3px;
					cursor: pointer;
				}
			}
		}


		&.chat-msg-mine {
			text-align: right;
			padding-left: 0;
			padding-right: 48px;

			.head-image {
				left: auto;
				right: 0;
			}

			.chat-msg-content {
				text-align: right;

				.chat-msg-top {
					flex-direction: row-reverse;
				}

				.chat-msg-bottom {
					padding-left: 180px;
					padding-right: 5px;

					.chat-msg-text {
						margin-left: 10px;
						background-color: var(--im-color-primary-light-2);
						color: #fff;

						&:after {
							left: auto;
							right: -10px;
							border-top-color: var(--im-color-primary-light-2);
						}
					}

					.chat-msg-image {
						flex-direction: row-reverse;
					}

					.chat-msg-video {
						flex-direction: row-reverse;
					}

					.chat-msg-file {
						flex-direction: row-reverse;
					}

					.chat-action {
						flex-direction: row-reverse;

						.iconfont {
							transform: rotateY(180deg);
						}
					}
				}
			}
		}

	}

	.chat-msg-card {
		display: flex;
		flex-direction: column;
		flex-wrap: nowrap;
		border-radius: 5px;
		padding: 12px 10px;
		width: 220px;
		position: relative;
		box-shadow: var(--im-box-shadow-dark);
		margin-top: 3px;

		// cursor: pointer;
		.card-body {
			flex: 1;
			display: flex;
			align-items: center;
			border-bottom: 3px solid #eee;
			position: relative;
			gap: 10px;
			padding-bottom: 12px;

			.name {
				font-weight: 600;
				white-space: nowrap;
				overflow: hidden;
				text-overflow: ellipsis;
				color: var(--im-text-color-light);
				font-size: var(--im-font-size-small);
			}
		}

		.card-tip {
			margin-top: 6px;
			text-align: left;
			color: var(--im-text-color-light);
			font-size: var(--im-font-size-small);
		}
	}

}
</style>